'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'mug-hot';
var width = 576;
var height = 512;
var aliases = [9749];
var unicode = 'f7b6';
var svgPathData = 'M144 0c-8.8 0-16 7.2-16 16 0 35.3 20.9 53.6 36.6 67.3l.8 .7c16.2 14.2 26.5 23.9 26.5 44 0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3-20.9-53.6-36.6-67.3l-.8-.7c-16.2-14.2-26.5-23.9-26.5-44 0-8.8-7.2-16-16-16zM96 224l320 0 0 192c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-192zm352 0l16 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l-16 0 0-160zm0 192l16 0c61.9 0 112-50.1 112-112S525.9 192 464 192L96 192c-17.7 0-32 14.3-32 32l0 192c0 53 43 96 96 96l192 0c53 0 96-43 96-96zM288 16c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.3 20.9 53.6 36.6 67.3l.8 .7c16.2 14.2 26.5 23.9 26.5 44 0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3-20.9-53.6-36.6-67.3l-.8-.7C298.3 45.8 288 36.1 288 16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMugHot = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;